import { Film, History, Layers, Music, Tv, Video } from "lucide-react";

import type { LucideIcon } from "lucide-react";

export const CONTENT_TYPE_ICONS = {
  video: Video,
  replay: History,
  audio: Music,
  master: Layers,
  live: Tv,
  external: Film,
} as const satisfies Record<string, LucideIcon>;

/** Clés : les noms d'icône que `getIcon` (utils/data/Content) range dans `content_type`. */
export const CONTENT_ICON_BY_NAME = {
  videocam: CONTENT_TYPE_ICONS.video,
  music_note: CONTENT_TYPE_ICONS.audio,
  replay: CONTENT_TYPE_ICONS.replay,
  live_tv: CONTENT_TYPE_ICONS.live,
  movie: CONTENT_TYPE_ICONS.external,
} as const satisfies Record<string, LucideIcon>;
